module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-packet-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-4"
  }, [(_vm.localValue.hasOwnProperty('_translatable')) ? [_c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.localValue._translatable.name,
      "label": "Name",
      "value": _vm.localValue.name
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.name),
      expression: "localValue.name"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localValue.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "name", $event.target.value)
      }
    }
  })])] : [_c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.name),
      expression: "localValue.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localValue.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "name", $event.target.value)
      }
    }
  })])], _c('label', [_vm._v("Amount"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.amount),
      expression: "localValue.amount"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localValue.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "amount", $event.target.value)
      }
    }
  })])], 2), _c('div', {
    staticClass: "columns large-8"
  }, [(!_vm.localValue.hasOwnProperty('_translatable')) ? [_c('label', [_vm._v("Description")])] : [_c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.localValue._translatable.description,
      "label": "Description",
      "value": _vm.localValue.description,
      "editor": true
    }
  })], _c('Editor', {
    model: {
      value: (_vm.localValue.description),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "description", $$v)
      },
      expression: "localValue.description"
    }
  })], 2)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-3"
  }, [_c('label', [_vm._v("Minutes")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.minutes),
      expression: "localValue.minutes"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localValue.minutes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "minutes", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "columns large-3"
  }, [_c('label', [_vm._v("Distance")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.distance),
      expression: "localValue.distance"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localValue.distance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "distance", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "columns large-3"
  }, [_c('label', [_vm._v("Duration")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.duration),
      expression: "localValue.duration"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localValue.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "duration", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "columns large-3"
  }, [_c('label', [_vm._v("Max Uses")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.max_uses),
      expression: "localValue.max_uses"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localValue.max_uses)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "max_uses", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "columns large-3"
  }, [_c('label', [_vm._v("Status")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.status),
      expression: "localValue.status"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localValue, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select status")]), _c('option', {
    attrs: {
      "value": "AVAILABLE"
    }
  }, [_vm._v("AVAILABLE")]), _c('option', {
    attrs: {
      "value": "UNAVAILABLE"
    }
  }, [_vm._v("UNAVAILABLE")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ada04ad!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/forms/PacketForm.vue
// module id = 2528
// module chunks = 1